export default "/carbon-footprint-calculator";
